const dafaultLanguage = {
  pageTitle: {
    ja: "NAPIRE Inc. | AIでビジネスをつなぐ — 法人向けAI・DX・クラウド導入支援",
    en: "NAPIRE Inc. | Connecting Business & AI — Enterprise AI, DX & Cloud",
  },
  metaDescription: {
    ja: "株式会社NAPIREはAI企業として、法人向けAI・DX導入支援、SaaS・クラウド導入支援、自社AIドローン開発を提供。生成AI・RAG、データ基盤、M365導入から本番運用まで一気通貫で伴走します。",
    en: "NAPIRE is an AI company offering enterprise AI/DX implementation, SaaS & cloud rollout, and in-house AI drones—from GenAI/RAG and data platforms to M365 adoption and production ops.",
  },
  metaKeywords: {
    ja: "NAPIRE,株式会社NAPIRE,AI導入,DX,法人向け,SaaS,クラウド,AIドローン,IT企業,生成AI",
    en: "NAPIRE,NAPIRE Inc.,AI implementation,DX,enterprise,SaaS,cloud,AI drone,IT company,GenAI",
  },
  nav: {
    home: { ja: "ホーム", en: "Home" },
    aiDx: { ja: "AI・DX", en: "AI & DX" },
    saasCloud: { ja: "クラウド", en: "Cloud" },
    drone: { ja: "AIドローン", en: "Drone" },
    products: { ja: "プロダクト", en: "Products" },
    itStore: { ja: "IT機器", en: "IT Store" },
    work: { ja: "実績", en: "Work" },
    about: { ja: "会社情報", en: "About" },
    team: { ja: "チーム", en: "Team" },
    insights: { ja: "インサイト", en: "Insights" },
    reports: { ja: "レポート", en: "Reports" },
    contact: { ja: "お問い合わせ", en: "Contact" },
    servicesGroup: { ja: "サービス", en: "Services" },
    companyGroup: { ja: "会社", en: "Company" },
    drawerTitle: { ja: "メニュー", en: "Menu" },
    menuOpen: { ja: "メニューを開く", en: "Open menu" },
    close: { ja: "閉じる", en: "Close" },
  },
  home: {
    pageTitle: {
      ja: "NAPIRE Inc. | AI・ITでビジネスをつなぐ",
      en: "NAPIRE Inc. | Connecting Business with AI & IT",
    },
    heroTitle: {
      ja: "AIとITで、現場が動くまで。",
      en: "AI & IT that moves the floor.",
    },
    heroLead: {
      ja: "NAPIREはAI・IT企業です。法人向けAI・DX導入支援、SaaS・クラウド導入支援を軸に、自社AIドローンというプロダクトまで一気通貫で届けます。",
      en: "NAPIRE is an AI & IT company—enterprise AI/DX, SaaS & cloud rollouts, and our own AI drone product, delivered end to end.",
    },
    heroCta: { ja: "サービスを見る", en: "Explore services" },
    heroCta2: { ja: "お問い合わせ", en: "Contact us" },
    stackMain: { ja: "AI・IT", en: "AI & IT" },
    stackMainSub: { ja: "法人向け導入支援の基盤", en: "Enterprise implementation foundation" },
    stackAi: { ja: "AI・DX導入支援", en: "AI & DX" },
    stackCloud: { ja: "SaaS・クラウド", en: "SaaS & Cloud" },
    stackDrone: { ja: "自社AIドローン", en: "AI Drone" },
    stackDroneSub: { ja: "プロダクト", en: "Product" },
    servicesLabel: { ja: "Services", en: "Services" },
    servicesTitle: { ja: "3つの柱", en: "Three pillars" },
    servicesLead: {
      ja: "IT・AIを上位概念とし、法人向け導入支援と自社プロダクトを組み合わせて提供します。",
      en: "AI & IT at the center—enterprise rollout plus our own product line.",
    },
    questionsLabel: { ja: "よくある問い", en: "Common questions" },
    questionsTitle: { ja: "気づかなかった違和感から、始めませんか。", en: "Start from the friction you almost ignored." },
    featuredLabel: { ja: "実績", en: "Work" },
    featuredTitle: { ja: "具体的なプロジェクト", en: "Concrete outcomes" },
    featuredMore: { ja: "すべての実績を見る", en: "View all work" },
    insightsLabel: { ja: "Insights", en: "Insights" },
    insightsTitle: { ja: "インサイト・コラム", en: "Insights & columns" },
    insightsLead: {
      ja: "AI導入、クラウド、ドローン——現場の視点で発信する最新コラムです。",
      en: "Field notes on AI adoption, cloud, and drones—from the NAPIRE bench.",
    },
    insightsMore: { ja: "すべてのコラムを見る", en: "View all insights" },
    insightsDateLabel: { ja: "公開日", en: "Published" },
    reportsLabel: { ja: "Reports", en: "Reports" },
    reportsTitle: { ja: "コンサルティングレポート", en: "Consulting reports" },
    reportsLead: {
      ja: "業界動向や特定トピックに関する分析・提言をまとめたレポートです。",
      en: "In-depth analysis and recommendations on industry trends and focused topics.",
    },
    reportsMore: { ja: "すべてのレポートを見る", en: "View all reports" },
    aboutLabel: { ja: "About", en: "About" },
    aboutTitle: {
      ja: "AI・ITで、現場が変わる。",
      en: "Where AI & IT meet the floor.",
    },
    aboutLead: {
      ja: "法人向け導入支援と自社プロダクトを軸に、課題の輪郭から本番運用まで一気通貫で届けるチームです。",
      en: "Enterprise rollout and our own products—one team from problem framing through production ops.",
    },
    aboutCta: { ja: "会社案内ページへ", en: "About NAPIRE" },
  },
  footer: {
    tagline: {
      ja: "AI・ITでビジネスと現場をつなぐ。",
      en: "Connecting business and the floor through AI & IT.",
    },
    copyright: { ja: "株式会社NAPIRE", en: "NAPIRE Inc." },
  },
  pages: {
    breadcrumbHome: { ja: "ホーム", en: "Home" },
    work: {
      pageTitle: { ja: "実績・事例 | 株式会社NAPIRE", en: "Work & Case Studies | NAPIRE Inc." },
      metaDescription: {
        ja: "NAPIREのプロジェクト実績。AI・DX、クラウド、ドローンなど具体的な導入事例をご紹介します。",
        en: "NAPIRE project outcomes—concrete case studies across AI/DX, cloud, and drones.",
      },
      metaKeywords: {
        ja: "NAPIRE,実績,事例,AI導入,DX,クラウド,ドローン,プロジェクト,法人向け",
        en: "NAPIRE,case studies,work,AI implementation,DX,cloud,drone,projects,enterprise",
      },
      heroLabel: { ja: "Work", en: "Work" },
      ctaTitle: { ja: "プロジェクトのご相談", en: "Discuss a project" },
      ctaText: {
        ja: "類似案件の進め方もお伝えできます。お気軽にご連絡ください。",
        en: "We can share how we'd approach similar engagements—reach out anytime.",
      },
      ctaBtn: { ja: "メールで相談", en: "Email us" },
    },
    about: {
      pageTitle: { ja: "会社情報 | 株式会社NAPIRE", en: "About | NAPIRE Inc." },
      metaDescription: {
        ja: "株式会社NAPIREの会社概要、メンバー体制、考え方をご紹介します。",
        en: "About NAPIRE—company overview, team, and how we work.",
      },
      metaKeywords: {
        ja: "NAPIRE,会社情報,会社概要,AI企業,IT企業,法人向け,DX,チーム",
        en: "NAPIRE,about,company overview,AI company,IT company,enterprise,DX,team",
      },
      heroLabel: { ja: "About", en: "About" },
      heroTitle: { ja: "会社情報", en: "About NAPIRE" },
      heroLead: {
        ja: "AI・ITを軸に、法人向け導入支援と自社プロダクトを届けるチームです。",
        en: "An AI & IT team delivering enterprise rollouts and our own products.",
      },
      overviewTitle: { ja: "会社概要", en: "Company overview" },
      thName: { ja: "会社名", en: "Company" },
      thFounded: { ja: "設立", en: "Founded" },
      thPlace: { ja: "所在地", en: "Location" },
      thBusiness: { ja: "事業内容", en: "Business" },
      thCapital: { ja: "資本金", en: "Capital" },
      teamCta: { ja: "メンバー紹介を見る", en: "Meet the team" },
    },
    insights: {
      pageTitle: { ja: "インサイト・コラム | 株式会社NAPIRE", en: "Insights | NAPIRE Inc." },
      metaDescription: {
        ja: "NAPIREのインサイト・コラム。AI導入、クラウド、ドローンに関する知見を発信します。",
        en: "NAPIRE insights and columns on AI adoption, cloud, and drones.",
      },
      metaKeywords: {
        ja: "NAPIRE,インサイト,コラム,AI導入,クラウド,ドローン,DX,技術コラム",
        en: "NAPIRE,insights,column,AI adoption,cloud,drone,DX,tech blog",
      },
      heroLabel: { ja: "Insights", en: "Insights" },
    },
    consultingReports: {
      pageTitle: {
        ja: "コンサルティングレポート | 株式会社NAPIRE",
        en: "Consulting Reports | NAPIRE Inc.",
      },
      metaDescription: {
        ja: "NAPIREのコンサルティングレポート。業界動向や特定トピックに関する分析・提言を掲載します。",
        en: "NAPIRE consulting reports—analysis and recommendations on industry trends and focused topics.",
      },
      metaKeywords: {
        ja: "NAPIRE,コンサルティングレポート,業界レポート,AI導入,DX,クラウド,ドローン",
        en: "NAPIRE,consulting report,industry report,AI adoption,DX,cloud,drone",
      },
      heroLabel: { ja: "Reports", en: "Reports" },
    },
    contact: {
      pageTitle: { ja: "お問い合わせ | 株式会社NAPIRE", en: "Contact | NAPIRE Inc." },
      metaDescription: {
        ja: "株式会社NAPIREへのお問い合わせフォーム。AI・DX、SaaS・クラウド、自社AIドローンなどのご相談はこちらから。",
        en: "Contact NAPIRE—enterprise AI/DX, SaaS & cloud, and in-house AI drones.",
      },
      metaKeywords: {
        ja: "NAPIRE,お問い合わせ,相談,AI導入,DX,SaaS,クラウド,AIドローン,法人向け",
        en: "NAPIRE,contact,inquiry,AI implementation,DX,SaaS,cloud,AI drone,enterprise",
      },
      heroLabel: { ja: "Contact", en: "Contact" },
      heroTitle: { ja: "お問い合わせ", en: "Contact us" },
      formNote: {
        ja: "ご入力いただいた内容は担当よりご連絡いたします。",
        en: "We'll get back to you after you submit the form.",
      },
      selectedProductLabel: { ja: "見積対象の商品", en: "Product for quotation" },
      selectedProductNote: {
        ja: "お問い合わせ内容に商品名を入力した状態でフォームを表示しています。数量・納品先・ご希望時期をご記入ください。",
        en: "The product name has been added to the inquiry. Please include quantity, delivery address, and preferred timing.",
      },
    },
  },
  sectionHub: {
    heading: {
      ja: "セクション一覧",
      en: "Sections",
    },
    lead: {
      ja: "カードを選ぶと、その内容を画面いっぱいで表示します。閉じるとこのページに戻ります。",
      en: "Choose a card to view that section full screen. Close to return here.",
    },
    close: {
      ja: "閉じる",
      en: "Close",
    },
  },
  scrollButtonText: {
    ja: "気になることを選ぶ",
    en: "Pick your question",
  },
  portal: {
    label: { ja: "NAPIRE / Portal", en: "NAPIRE / Portal" },
    heading: { ja: "何が気になりますか？", en: "What's on your mind?" },
    sub: {
      ja: "当社の知りたい項目を選んでください。選ぶと、NAPIREの答えと次のステップが表示されます。",
      en: "Pick what you want to explore—we'll show how NAPIRE answers it and where to go next.",
    },
    choices: [
      {
        id: "ai",
        label: { ja: "AIで何ができるの？", en: "What can AI actually do?" },
        answer: {
          ja: "生成AI・RAG、画像認識、需要予測——課題に合わせて選び、PoCで終わらせず本番まで伴走します。自社ドローンで培った実装力が、法人のAI導入にも活きます。",
          en: "GenAI/RAG, vision, forecasting—scoped to your problem, shipped past the PoC deck. The same build discipline we use on our drones, applied to your enterprise AI.",
        },
        cta: { ja: "AI・DX導入支援を見る", en: "Explore AI & DX" },
        target: "ai-dx.html",
      },
      {
        id: "cloud",
        label: { ja: "SaaS・クラウド、何から始める？", en: "SaaS & cloud—where do we start?" },
        answer: {
          ja: "Microsoft 365・Google Workspace、SaaS・AI・セキュリティ・クラウド製品の仕入れから移行・定着まで。ライセンス契約で終わらせず、AI連携を見据えたデータ基盤まで設計します。",
          en: "From procurement of M365, Google Workspace, SaaS, AI, security, and cloud—through migration, adoption, and data foundations ready for AI. Not just licenses.",
        },
        cta: { ja: "SaaS・クラウド導入支援を見る", en: "Explore SaaS & cloud" },
        target: "saas-cloud.html",
      },
      {
        id: "poc",
        label: { ja: "PoCは成功したのに本番に乗らない", en: "PoC worked—production didn't" },
        answer: {
          ja: "データ品質・権限・MLOpsを最初から織り込むのが私たちの標準です。コンサルで終わらず、コードが動くところまで同じチームが責任を持ちます。",
          en: "We weave data quality, access, and MLOps in from day one—one squad from framing through production code.",
        },
        cta: { ja: "実績を見る", en: "See our work" },
        target: "#proof",
      },
      {
        id: "drone",
        label: { ja: "自社ドローンって何が違う？", en: "What's different about your drones?" },
        answer: {
          ja: "キットを組むのではなく、用途から機体・推力・センサを設計。だから飛行制御も認識AIも「この機体のための」コードだけが書けます。",
          en: "We don't assemble kits—we size frames, thrust, and sensors for the mission. Flight and perception are authored for this airframe only.",
        },
        cta: { ja: "ドローンを見る", en: "Explore drones" },
        target: "#drone",
      },
      {
        id: "team",
        label: { ja: "どんなチームが入るの？", en: "Who actually shows up?" },
        answer: {
          ja: "AIストラテジー、フルスタック、クラウド、組み込み——プロジェクトに必要な役割ごとに、設計から実装まで入ります。",
          en: "Strategy, full-stack, cloud, embedded—the roles your project needs, from design through build.",
        },
        cta: { ja: "体制を見る", en: "Meet the roles" },
        target: "#team",
      },
      {
        id: "talk",
        label: { ja: "まず話を聞いてみたい", en: "I just want to talk first" },
        answer: {
          ja: "資料は不要です。オンラインで30分、課題の輪郭からお聞かせください。",
          en: "No deck required—book 30 minutes and tell us where you are.",
        },
        cta: { ja: "相談する", en: "Get in touch" },
        target: "contact.html",
      },
    ],
  },
  hero: {
    eyebrow: {
      ja: "株式会社NAPIRE（ネイピア）",
      en: "NAPIRE Inc.",
    },
    line1: {
      ja: "Connecting",
      en: "Connecting",
    },
    line2: {
      ja: "Business",
      en: "Business",
    },
    line3: {
      ja: "& AI",
      en: "& AI",
    },
    ribbon: {
      ja: "ドローンは、仕入れたキットを並べるだけではなく、現場の話から機体を起こしています。推力やセンサが見えてからコードを書く——その順番を、私たちは大切にしています。",
      en: "We grow our drones out of field conversations, not a shopping list of parts—and we only start writing software once the airframe story feels honest.",
    },
    lead: {
      ja: "AI企業として、法人向けAI・DX導入支援とSaaS・クラウド導入支援に加え、自社AIドローンを機体から設計。ハードとソフトを同じチームで握るからこそ、現場で動くAIを届けます。",
      en: "As an AI company, we deliver enterprise AI/DX and SaaS/cloud rollouts—plus in-house drones built from the airframe up. One team owns hardware and software, so AI survives contact with the real world.",
    },
    scrollHint: {
      ja: "SCROLL",
      en: "SCROLL",
    },
    sideLabel: {
      ja: "AI COMPANY × DRONE × CLOUD",
      en: "AI COMPANY × DRONE × CLOUD",
    },
    bootLines: {
      ja: [
        "system.init() — NAPIRE AI LAB",
        "loading modules: gen_ai, cv, mlops, edge...",
        "status: ready to connect business & AI",
      ],
      en: [
        "system.init() — NAPIRE AI LAB",
        "loading modules: gen_ai, cv, mlops, edge...",
        "status: ready to connect business & AI",
      ],
    },
  },
  story: {
    eyebrow: { ja: "あなたの隣で、考える", en: "Questions at your side" },
    heading: {
      ja: "気づかなかった問いが、DXの入口になる。",
      en: "The question you skipped is where DX starts.",
    },
    lead: {
      ja: "明電舎の「あなたの隣で」が示すように、いきなり技術を語るのではなく、現場の違和感から入る。NAPIREも同じです。",
      en: "Like Meidensha's 'at your side' approach—we don't open with specs. We start with the friction your floor already feels.",
    },
    questions: [
      {
        q: {
          ja: "AIを導入したのに、誰も使っていない——それ、本当に導入ですか？",
          en: "You 'deployed' AI—nobody uses it. Was that really deployment?",
        },
        bridge: {
          ja: "→ ユースケース設計と定着支援まで、NAPIREが伴走します。",
          en: "→ NAPIRE partners through use-case design and adoption—not just licenses.",
        },
      },
      {
        q: {
          ja: "PoCは成功した。でも本番に乗らない——何が足りなかった？",
          en: "The PoC worked. Production didn't. What was missing?",
        },
        bridge: {
          ja: "→ データ品質・権限・MLOpsを最初から織り込む実装力があります。",
          en: "→ We weave data quality, access, and MLOps in from day one.",
        },
      },
      {
        q: {
          ja: "SaaS・AI・セキュリティ製品をまとめて仕入れたい——どこから？",
          en: "We need SaaS, AI, and security products—where do we start?",
        },
        bridge: {
          ja: "→ M365・GWS、SaaS・AI・セキュリティ・クラウド製品の仕入れから導入・定着まで一括で支援します。",
          en: "→ Procurement for M365, GWS, SaaS, AI, security, and cloud—through rollout and adoption.",
        },
      },
    ],
    cta: {
      ja: "あなたの問いを聞かせてください",
      en: "Tell us your question",
    },
  },
  solutions: {
    eyebrow: { ja: "法人向けソリューション", en: "Enterprise solutions" },
    heading: {
      ja: "導入して、使われるまで。",
      en: "Ship it—and make it stick.",
    },
    lead: {
      ja: "FBJやWoodrowのような導入支援の知見を活かしつつ、AI企業ならではの実装力で本番まで伴走します。",
      en: "Enterprise rollout discipline—plus an AI builder's instinct for what survives production.",
    },
    aiDx: {
      tag: { ja: "Enterprise AI / DX", en: "Enterprise AI / DX" },
      title: { ja: "法人向けAI・DX導入支援", en: "Enterprise AI & DX" },
      desc: {
        ja: "生成AI・RAG、Computer Vision、需要予測からデータ基盤・MLOpsまで。PoCで終わらせない。",
        en: "GenAI/RAG, vision, forecasting, data platforms, MLOps—beyond the PoC deck.",
      },
      cta: { ja: "詳しく見る", en: "Learn more" },
      href: "ai-dx.html",
    },
    saasCloud: {
      tag: { ja: "SaaS / Cloud", en: "SaaS / Cloud" },
      title: { ja: "SaaS・クラウド導入支援", en: "SaaS & cloud rollout" },
      desc: {
        ja: "M365・GWS、SaaS・AI・セキュリティ・クラウド製品の仕入れから移行・定着まで一気通貫。",
        en: "Procurement for M365, GWS, SaaS, AI, security, and cloud—through migration and adoption.",
      },
      cta: { ja: "詳しく見る", en: "Learn more" },
      href: "saas-cloud.html",
    },
  },
  insights: {
    eyebrow: { ja: "Insights / Column", en: "Insights / Column" },
    heading: { ja: "AIと現場のあいだ", en: "Between AI and the floor" },
    lead: {
      ja: "導入の現場で見えてきたこと、技術選定の判断軸、失敗から学んだこと——NAPIREの視点を発信していきます。",
      en: "Field notes, selection heuristics, lessons from what didn't work—perspectives from the NAPIRE bench.",
    },
    articles: [
      {
        tag: { ja: "生成AI", en: "GenAI" },
        title: {
          ja: "RAGを本番で回すために、最初に決めるべき5つのこと",
          en: "Five decisions before RAG hits production",
        },
        desc: {
          ja: "検索精度だけでなく、権限・コスト・評価指標をどう設計するか。",
          en: "Beyond retrieval accuracy—access, cost, and evaluation from the start.",
        },
        date: { ja: "2025.08", en: "Aug 2025" },
      },
      {
        tag: { ja: "クラウド", en: "Cloud" },
        title: {
          ja: "M365導入で「使われる」環境をつくる3つのポイント",
          en: "Three patterns for M365 that actually gets used",
        },
        desc: {
          ja: "ライセンス契約で終わらせない。業務フローと研修設計の話。",
          en: "Licenses aren't the finish line—workflows and training design are.",
        },
        date: { ja: "2025.07", en: "Jul 2025" },
      },
      {
        tag: { ja: "ドローン × AI", en: "Drone × AI" },
        title: {
          ja: "機体を自社で設計すると、AIの精度が変わる理由",
          en: "Why owning the airframe changes your AI accuracy",
        },
        desc: {
          ja: "カメラの露出・振動・FPS——ハード制約がモデル設計を決める。",
          en: "Exposure, vibration, FPS—hardware constraints that shape your models.",
        },
        date: { ja: "2025.06", en: "Jun 2025" },
      },
    ],
    comingSoon: {
      ja: "記事を準備中です。しばらくお待ちください。",
      en: "Articles are on the way—please check back soon.",
    },
  },
  consultingReports: {
    eyebrow: { ja: "Consulting Reports", en: "Consulting Reports" },
    heading: { ja: "業界とトピックを読み解く", en: "Reading industries and topics" },
    lead: {
      ja: "特定の業界・テーマに対する分析と提言を、コンサルティングレポートとして公開していきます。",
      en: "We publish structured analysis and recommendations on specific industries and themes.",
    },
    comingSoon: {
      ja: "レポートを準備中です。しばらくお待ちください。",
      en: "Reports are on the way—please check back soon.",
    },
  },
  reportDownload: {
    pageLabel: { ja: "ページ", en: "Page" },
    lockedLabel: {
      ja: "数値・詳細はダウンロードでご覧ください",
      en: "Numbers and details are in the download",
    },
    teaserLabel: {
      ja: "図表の詳細・全文はダウンロードで",
      en: "Full charts and text are in the download",
    },
    lockedCta: { ja: "全文をダウンロード", en: "Download full PDF" },
    formEyebrow: { ja: "Download", en: "Download" },
    formTitle: {
      ja: "レポートをダウンロード",
      en: "Download the report",
    },
    formLead: {
      ja: "お名前・会社名・メールアドレスをご入力ください。送信後、PDFのダウンロードが始まります。",
      en: "Enter your name, company, and email. The PDF download will start after you submit.",
    },
    labelName: { ja: "お名前", en: "Name" },
    labelCompany: { ja: "会社名", en: "Company" },
    labelEmail: { ja: "メールアドレス", en: "Email" },
    placeholderName: { ja: "山田 太郎", en: "Jane Doe" },
    placeholderCompany: { ja: "株式会社サンプル", en: "Acme Inc." },
    placeholderEmail: { ja: "you@example.com", en: "you@example.com" },
    consentLabel: {
      ja: "個人情報の取扱いに同意のうえ、レポートを受け取ります。",
      en: "I agree to the handling of my personal information and wish to receive the report.",
    },
    submit: { ja: "PDFをダウンロード", en: "Download PDF" },
    submitting: { ja: "送信中…", en: "Submitting…" },
    success: {
      ja: "ダウンロードを開始しました。別タブが開かない場合はポップアップを許可してください。",
      en: "Download started. Allow pop-ups if a new tab did not open.",
    },
    successNewTab: {
      ja: "新しいタブでダウンロードを開始します。タブが開かない場合はポップアップを許可してください。",
      en: "Starting download in a new tab. Allow pop-ups if it did not open.",
    },
    popupBlocked: {
      ja: "ポップアップがブロックされました。ブラウザで許可してから再度お試しください。",
      en: "Pop-up blocked. Allow pop-ups for this site and try again.",
    },
    failed: {
      ja: "送信に失敗しました。時間をおいて再度お試しください。",
      en: "Something went wrong. Please try again in a moment.",
    },
    notConfigured: {
      ja: "ダウンロード受付の準備中です。しばらくしてからお試しください。",
      en: "Downloads are being set up. Please try again shortly.",
    },
    consentRequired: {
      ja: "個人情報の取扱いへの同意が必要です。",
      en: "Please agree to the handling of personal information.",
    },
    missingFields: {
      ja: "必須項目をすべて入力してください。",
      en: "Please fill in all required fields.",
    },
    invalidEmail: {
      ja: "メールアドレスの形式をご確認ください。",
      en: "Please check the email address format.",
    },
  },
  marquee: {
    items: {
      ja: [
        "自社ドローン",
        "機体設計",
        "モジュール搭載",
        "自律飛行",
        "エッジ推論",
        "生成AI",
        "RAG",
        "データ基盤",
        "MLOps",
        "上流設計",
        "Computer Vision",
        "OCR",
        "需要予測",
        "フルスタック開発",
        "AWS / GCP / Azure",
        "プロダクト思考",
      ],
      en: [
        "In-house drones",
        "Airframe design",
        "Modular payloads",
        "Autonomous flight",
        "Edge inference",
        "GenAI",
        "RAG",
        "Data platforms",
        "MLOps",
        "Discovery",
        "Computer vision",
        "OCR",
        "Forecasting",
        "Full-stack build",
        "AWS / GCP / Azure",
        "Product mindset",
      ],
    },
  },
  statement: {
    mega: {
      ja: "AI・DX、クラウド、プロダクト——三つの柱で届ける。",
      en: "AI & DX, cloud, and product—delivered as three pillars.",
    },
    sub: {
      ja: "法人向けAI・DX導入、SaaS・クラウドの立ち上げ、自社AIドローンの開発。いずれも課題の整理から実装・検証・運用まで、同じチームが本番まで責任を持って伴走します。",
      en: "Enterprise AI & DX, SaaS & cloud rollout, and in-house AI drones—from scoping through build, validation, and ops, one accountable team through production.",
    },
  },
  drone: {
    sideways: { ja: "PRODUCT", en: "PRODUCT" },
    eyebrow: { ja: "Flagship ／ 自社プロダクト", en: "Flagship ／ In-house product" },
    title: {
      ja: "ドローンは、白紙の機体から。",
      en: "Drones from a blank airframe.",
    },
    lead: {
      ja: "キットを組むのではなく、用途から機体サイズ・推力・センサ構成を決め、モジュールを載せ切るところまで自社で握ります。だからこそ、飛行制御から認識AIまで「この機体のための」ソフトウェアだけが書ける。",
      en: "We don't stop at off-the-shelf kits—we size the frame, thrust, and sensor stack for the mission, integrate modules, and own the stack end to end. That's why flight, failsafes, and perception are authored for this airframe—not a generic SDK demo.",
    },
    hardwareHeading: { ja: "ハードウェア（機体・モジュール）", en: "Hardware — airframe & modules" },
    hardwareBody: {
      ja: "機体選定〜カスタムフレーム、プロペラ、ESC、バッテリー、各種センサのマウントまでを一つの設計として進行。現場の風・高度・航続で逆算します。",
      en: "We run selection or custom frames, propulsion, ESCs, power budgets, and physical sensor mounts as one system—traded against wind, altitude, and endurance your field actually sees.",
    },
    hardwareBullets: {
      ja: [
        "機体・推力・重量バランスを用途から設計し、必要なら小型〜中型クラスまで調達・実装を統合",
        "カメラ／深度／GNSS 等の搭載位置と配線まで含めて決定し、振動・ホワイトバランス等の実機制約を先に取り込む",
        "「飛ばす」だけでなく、点検・交換・現場運用を見据えたモジュール構成",
      ],
      en: [
        "Frame and thrust budgets sized from mission profiles—integrating procurement and build from small to mid-sized classes when needed",
        "Camera, depth, GNSS placement, wiring, and vibration budgets locked early—not patched after the fact",
        "Layouts meant for field maintenance, swaps, and operator workflows—not one-off demos",
      ],
    },
    bridge: {
      ja: "機体・推進・センサを自社で設計しているから",
      en: "Because we own the airframe, propulsion, and sensors",
    },
    softwareHeading: { ja: "ソフトウェア（制御・認識・地上系）", en: "Software — control, perception, ground" },
    softwareBody: {
      ja: "一般のWebアプリ開発とは別レイヤ。推進系の応答、IMUのノイズ、カメラのローリングシャッターまで踏まえて、制御ループと推論パイプラインを結線します。",
      en: "This isn't generic web work—it's closing loops between propulsion response, IMU noise, rolling shutter, and the perception graphs that must run on the payload budget you actually have.",
    },
    softwareBullets: {
      ja: [
        "安定化・高度保持・フェイルセーフを、実機の慣性・推力モデルに合わせてチューニング",
        "画像検知・追従・マッピングは、搭載カメラの解像度・FPS・露出前提でモデルと後処理を設計",
        "地上局、ログ、OTA、遥測のストーリングまで含めて「運用で死なない」形に",
      ],
      en: [
        "Stabilization, altitude hold, and failsafes tuned against real inertia and thrust—not a simulator default",
        "Detection, tracking, and mapping pipelines scoped to the resolution, FPS, and exposure you truly carry",
        "Ground station, logging, OTA, and telemetry paths designed for long-running ops—not lab-only scripts",
      ],
    },
    modulesLabel: { ja: "搭載モジュール例（要件に応じて可変）", en: "Example payloads (mission-specific)" },
    modulePills: {
      ja: ["GPS / GNSS", "深度カメラ", "RGBカメラ", "エッジ推論", "安定化制御", "LTE・5G", "自律探索"],
      en: ["GPS / GNSS", "Depth camera", "RGB camera", "Edge inference", "Stabilized control", "LTE / 5G", "Autonomous routing"],
    },
    footnote: {
      ja: "資料で示したPoCでは、画像認識による自律探索ドローンで空撮を取得し、分布可視化までを検証。同様に、監視・農業・物流・災害など多様なユースケースへモジュール構成を拡張できます。",
      en: "Our materials walk through a PoC where a vision-guided autonomous drone captured aerials and surfaced distribution maps—the same modular approach extends to security, agriculture, logistics, disaster response, and more.",
    },
  },
  value: {
    title: { ja: "なぜ、今つなぐのか", en: "Why connect now" },
    body: {
      ja: "ツール導入だけでは現場は動きません。課題の輪郭を描き、データとアルゴリズムを選び、プロダクトとして残すまでを短いサイクルで回せることが、成果的なAIになります。",
      en: "Buying tools doesn't move the floor. Real AI ties problem framing, data, modeling, and product delivery into tight loops—so outcomes stick.",
    },
    panelCaption: {
      ja: "意思決定が速くなるほど、現場は前に進む。だからこそ、設計と実装を同じテーブルに載せます。",
      en: "When decisions accelerate, teams move. That's why design and implementation share one table.",
    },
    chips: {
      ja: [
        "自社AIドローン（機体〜ソフト）",
        "生成AI / CV / NLP / 予測",
        "クラウド・データ基盤・運用",
      ],
      en: [
        "In-house AI drones (airframe to software)",
        "GenAI · CV · NLP · forecasting",
        "Cloud, data platforms, operations",
      ],
    },
  },
  philosophy: {
    philosophy1: {
      ja: "『つなぐ』は、技術を押し付けることではありません。現場の制約と成果指標を尊重し、説明可能で保守できる形に落とすことです。",
      en: "'Connect' doesn't mean pushing tech. It means respecting constraints and KPIs—shipping maintainable, explainable systems.",
    },
    philosophy2: {
      ja: "明るく、前向きに、それでいてプロフェッショナルに。対話を重ねながら、次の打ち手が見えるドキュメントとプロダクトを残します。",
      en: "Bright, optimistic, and deeply professional. We leave behind artifacts—docs and product—that make the next step obvious.",
    },
  },
  business: {
    business1: {
      title: {
        ja: "AIコンサルティング / 実装",
        en: "AI consulting & build",
      },
      detail: {
        ja: "最新の研究動向を踏まえつつ、ROIが見えるユースケースに絞り込み。RAG・LLM、画像検知・OCR、需要予測など、課題に合わせて選定し、本番運用まで伴走します。",
        en: "We pair research literacy with pragmatic scoping—RAG/LLMs, vision & OCR, forecasting—then ship to production with you, not at you.",
      },
    },
    business2: {
      title: {
        ja: "ビッグデータ解析・データ基盤",
        en: "Big data & data platforms",
      },
      detail: {
        ja: "散在するログや販売・設備データを取り込み、クレンジングから特徴設計、ダッシュボード化まで。AWS/GCP/Azure 上で学習ループが回る形を設計します。",
        en: "From ingestion and cleansing to features and dashboards on AWS/GCP/Azure—architectures where models keep learning without silently drifting.",
      },
    },
    business3: {
      title: {
        ja: "ソフトウェア開発（Web / モバイル / 組み込み）",
        en: "Software engineering (web, mobile & embedded)",
      },
      detail: {
        ja: "プロトタイプから社内向けツール、外部公開サービスまで。フロント〜バックエンド、インフラに加え、自社ドローン向けの組み込み・地上局・ログ基盤までワンチームで組み立てます。",
        en: "From internal tools to customer-facing apps—frontend, backend, and infra—plus ground stations, logging, and embedded paths for our own drone stack, delivered as one team.",
      },
    },
  },
  proof: {
    title: {
      ja: "中身まで具体的なプロジェクト実績",
      en: "Concrete project outcomes",
    },
    subtitle: {
      ja: "どの業界のどんなテーマか、そしてどこまで成果が出たかが伝わるよう、業種と取り組みの内容で示しています。要件の整理や設計にとどまらず、開発・検証・本番に近い運用まで当事者として関わった案件のみを載せています。",
      en: "We state the industry, the problem shape, and how far we took the work. These are engagements where we stayed involved past slide decks—through build, validation, and production-adjacent delivery.",
    },
    cases: [
      {
        tag: { ja: "自社ドローン × 農業", en: "In-house drone" },
        title: {
          ja: "自律探索ドローンによる空撮と分布マップのPoC",
          en: "PoC: autonomous scouting, aerials, distribution maps",
        },
        desc: {
          ja: "画像認識で自律走行する機体を用い、GPS連携で圃場上空を走査。空撮を取り込み、病害虫分布などの可視化までを一連で検証。",
          en: "Vision-guided autonomous passes linked with GPS, ingesting aerials to validate distribution-style analytics—exactly the hardware–software coupling we ship in-house.",
        },
      },
      {
        tag: { ja: "防災 × 予測AI", en: "Resilience AI" },
        title: {
          ja: "災害廃棄物の発生量・設置・処理フローを高精度に推定",
          en: "Forecasting disaster waste volumes, placement, and flows",
        },
        desc: {
          ja: "公共オープンデータと都市計画・地図情報を統合し、被災パターンごとの発生量を可視化。現場判断を早めるダッシュボードまで実装。",
          en: "Fused open civic data with planning and mapping signals to surface scenario-level forecasts—shipping operator-ready dashboards.",
        },
      },
      {
        tag: { ja: "越境EC × 価格AI", en: "Cross-border commerce" },
        title: {
          ja: "グローバル買取・販売データの収集基盤と価格予測モデル",
          en: "Global pricing intelligence on a living dataset",
        },
        desc: {
          ja: "常時クロールするデータレイクと学習パイプラインをクラウド上に構築。最新相場を反映し続ける予測機能をプロダクトへ統合。",
          en: "Built continuous ingestion plus cloud-native training loops so price signals refresh as markets move—not as quarterly batch jobs.",
        },
      },
      {
        tag: { ja: "生成AI × 社内ナレッジ", en: "GenAI & knowledge" },
        title: {
          ja: "RAGとLLMを組み合わせたエンタープライズチャット",
          en: "Enterprise chat blending RAG with LLMs",
        },
        desc: {
          ja: "社内ドキュメントを安全に検索し、根拠付きで回答。検索と生成を分離したアーキテクチャで運用コストとハルシネーションリスクを抑制。",
          en: "Grounded answers over internal corpora—architecture separating retrieval and generation to tame ops cost and hallucination risk.",
        },
      },
      {
        tag: { ja: "建設安全 × NLP", en: "Safety analytics" },
        title: {
          ja: "数万件規模の災害事例テキストを自動分類・類似検索",
          en: "Classifying & surfacing patterns across tens of thousands of incident narratives",
        },
        desc: {
          ja: "厚労省などの広範な報告文書を機械学習でタグ付けし、類似災害を瞬時に参照。定性情報を意思決定に使えるデータへ変換。",
          en: "Turned massive regulatory and incident corpora into navigable intelligence—similar-case retrieval for proactive safety planning.",
        },
      },
      {
        tag: { ja: "エネルギー × 需要予測", en: "Energy forecasting" },
        title: {
          ja: "多変量ビッグデータを用いた電力需要予測と劣化しにくい学習基盤",
          en: "Robust power-demand forecasting on heterogeneous big data",
        },
        desc: {
          ja: "気象・需要・再エネなど複数系列を特徴として統合。モデル劣化を抑える再学習設計とモニタリングを一体で提供。",
          en: "Fused weather, demand, and renewables signals with MLOps-minded refresh—so accuracy doesn't quietly decay after launch.",
        },
      },
      {
        tag: { ja: "消費財 × OCR", en: "Retail OCR" },
        title: {
          ja: "レシート画像からの検知・認識・構造化パイプライン",
          en: "Detection, recognition, structuring for receipt imagery",
        },
        desc: {
          ja: "キー項目の自動判別と人的確認フローを両立。マーケティング調査のボトルネックだった転記作業を大幅に圧縮。",
          en: "Balanced automation with human-in-the-loop QA—shrinking the transcription bottleneck for consumer insight programs.",
        },
      },
    ],
  },
  team: {
    title: {
      ja: "チーム紹介",
      en: "Our team—by role and expertise",
    },
    subtitle: {
      ja: "各メンバーの役割・略歴・プロジェクト実績を掲載しています。プロジェクトで必要となる役割ごとに、どのような専門性で参画するかをご確認いただけます。",
      en: "Roles, backgrounds, and project records for each member—see the expertise they bring to your engagement.",
    },
    roles: [
      {
        title: { ja: "AIストラテジー / リサーチ", en: "AI strategy & research" },
        body: {
          ja: "画像・音声・予測モデルまで横断し、論文と実装のギャップを埋める。PoCで終わらせず、本番指標に落とす設計をリード。",
          en: "Spins up CV, audio, and forecasting with equal fluency—closing the lab-to-prod gap and anchoring on production KPIs.",
        },
      },
      {
        title: { ja: "ビジネス開発 / PM", en: "BD & program leadership" },
        body: {
          ja: "小売の立ち上げから製造業の基幹リプレイスまで、利害調整とスコープ管理に強い。非エンジニアとの要件セッションを前に進める。",
          en: "From retail launches to core-system replays—strong at stakeholder alignment and scope guardrails that keep teams shipping.",
        },
      },
      {
        title: { ja: "フルスタック開発", en: "Full-stack engineering" },
        body: {
          ja: "React / Vue / TypeScript、Ruby / Python / Node、コンテナとCIまで。多言語チームでの開発プロセス設計も得意。",
          en: "React/Vue/TS, Ruby/Python/Node, containers & CI—comfortable orchestrating multilingual engineering squads.",
        },
      },
      {
        title: { ja: "クラウド / PMO", en: "Cloud & PMO" },
        body: {
          ja: "大規模インフラ案件で鍛えたアーキテクチャとガバナンス。短期間での本番移行、運用引き継ぎ、セキュリティ観点の整理まで含める。",
          en: "Architecture and governance hardened on large programs—tight cutovers, operational handoffs, and pragmatic security framing.",
        },
      },
      {
        title: { ja: "組み込み / ドローン実装", en: "Embedded & drone stack" },
        body: {
          ja: "飛行制御・センサ融合・エッジ推論まで、機体の物理制約を前提に実装。ドローン事業ではハード選定と同じチームがソフトを書き切る。",
          en: "Flight stacks, sensor fusion, and edge inference written against physical limits—the same squad that picks hardware also ships the code.",
        },
      },
    ],
  },
  sectionLabels: {
    services: { ja: "提供サービス", en: "What we deliver" },
    philosophyHeading: { ja: "考え方", en: "Belief" },
  },
  contact: {
    heading: {
      ja: "次の一歩を、具体にする",
      en: "Make the next step concrete",
    },
    description: {
      ja: "まずは課題の輪郭から。資料は不要です、オンラインで30分お話ししましょう。",
      en: "Start messy—we like it. No slide deck required; book a 30-minute virtual chat.",
    },
    buttonText: {
      ja: "お問い合わせフォームへ",
      en: "Go to contact form",
    },
    formLink: {
      ja: "お問い合わせフォーム",
      en: "Contact form",
    },
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSc45BmyZVwICEmeBl_PPQsOA6Q96N1bLEHCi6j8d5pB-0aGTA/viewform?embedded=true",
  },
  company: {
    name: {
      ja: "会社名: 株式会社NAPIRE (英文社名: NAPIRE Inc.)",
      en: "Company Name: NAPIRE Inc.",
    },
    representative: {
      ja: "",
      en: "",
    },
    builtDate: {
      ja: "設立日: 2024/01/04",
      en: "Established: 2024/01/04",
    },
    place: {
      ja: "オフィス所在地: 〒107-0062 東京都港区南青山3丁目1番36号青山丸竹ビル6F",
      en: "Office Location: 〒107-0062  Aoyamamarutake 6F, 3-1-36 Minamiaoyama, Minato-ku, Tokyo, Japan",
    },
    content: {
      ja: "事業内容: 法人向けAI・DX導入支援、SaaS・クラウド導入支援、AI開発/コンサルティング、ビッグデータ解析、ソフトウェア開発、自社AIドローン開発",
      en: "Business: Enterprise AI/DX, SaaS & cloud rollout, AI consulting, big data, software engineering, in-house AI drones",
    },
    capital: {
      ja: "資本金: 1,000,000円",
      en: "Capital: 1,000,000 yen",
    },
  },
  vision: {
    title: {
      ja: "ビジョン",
      en: "vision",
    },
    description1: {
      ja: "弊社が持ち合わせているAI技術や高度IT技術を様々な企業に提供し、ビジネスに更なる加速を生み出します。",
      en: "We provide our AI and advanced IT technologies to various companies to further accelerate their business.",
    },
    description2: {
      ja: "DX協業を行ってビジネスを加速させたい方はぜひご連絡ください。",
      en: "If you are interested in accelerating your business through DX collaboration, please contact us.",
    },
    button: {
      ja: "連絡",
      en: "contact",
    },
    image: {
      ja: "dx_kyougyou.png",
      en: "dx_kyougyou_en.png",
    },
  },
}
